import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

export const TitleWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  paddingTop: '48px',
  paddingBottom: '48px',
}))

export const Title = styled(Typography)({
  fontSize: '50px',
  fontWeight: 800,
})

export const Content = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  paddingTop: '48px',
  paddingLeft: '96px',
  paddingRight: '96px',
  paddingBottom: '96px',
}))

export const Message = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  paddingBottom: '32px',
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
}))

export const Time = styled(Typography)({
  margin: '32px 0 16px 0',
  fontSize: '16px',
  fontWeight: 'bold',
})

export const ErrorWrapper = styled(Box)({
  backgroundColor: 'var(--surface-50)',
  padding: '32px',
  fontSize: '16px',
})

export const ErrorLabel = styled('span')({
  marginRight: '8px',
})

export const ErrorText = styled('span')(({ theme }) => ({
  color: theme.palette.error.main,
}))
